import styled, { css } from 'styled-components';
import {
  issueStatusColors,
  issueStatusBackgroundColors,
  mixin,
} from 'utils/styles';

export const Status = styled.div`
  min-width: 80px;
  text-transform: uppercase;
  transition: all 0.1s;
  text-align: center;
  margin: auto;
  ${(props) =>
    mixin.tagIssueListStatus(
      issueStatusBackgroundColors[props.color],
      issueStatusColors[props.color]
    )}
  ${(props) =>
    props.isValue &&
    css`
      padding: 0 12px;
      height: 40px;
      &:hover {
        transform: scale(1.05);
      }
    `}
`;
